// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"_1t9eHNOUpl24wTyntjMx_9","title":"_38q4SQEzdL4dxAbR93XFso","triangleRight":"_3epQChx6cxiBtC67-0oTN9","triangleDown":"_1WcMlAAaxrSumEQ6BjjD44","closed":"_1tKW8BvIxnCd_FVTtGVUbF"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/accordion.css
// module id = 788
// module chunks = 0